import React, { ReactChild, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

import { requestDeferred, requestImmediate } from "../util/RenderManager";

type Props = {
  placeholder?: ReactChild;
  children?: ReactChild;
};

export const RenderQueue = ({ placeholder, children }: Props) => {
  const [inViewRef, inView] = useInViewOnce();

  const [canRender, setCanRender] = useState(() =>
    //
    // Can we just render right away
    //
    requestImmediate(),
  );

  useEffect(() => {
    if (inView && !canRender) {
      //
      // If we didn't render immediately, ask to be given permission when it's our turn
      //
      requestDeferred(() => setCanRender(true));
    }
    // We don't need to re-fire this hook when canRender flips to true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <>
      <div ref={inViewRef} />
      {canRender ? children : placeholder}
    </>
  );
};

const useInViewOnce = () => {
  const [inViewRef, inView] = useInView();
  const [hasBeenInView, setHasBeenInView] = useState(inView);
  useEffect(() => {
    if (inView) setHasBeenInView(true);
  }, [inView]);
  return [inViewRef, hasBeenInView] as const;
};
